import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { SearchService } from "../../../../services/search.service";
import * as moment from "moment";
import { IntegratorService } from "../../../../services/integrator.service";
import {
  environment as params,
  environment
} from "src/environments/environment";

declare var $: any;

@Component({
  selector: "app-step-two",
  templateUrl: "./step-two.component.html",
  styleUrls: ["./step-two.component.scss"],
  providers: [SearchService]
})
export class StepTwoComponent implements OnInit {
  public consoleData: any;
  public passengers: any = null;
  public prod: any;
  public totalViajeros: any;
  public totalNormal: any;
  public totalIsic: any;
  public form: FormGroup;
  public optionsInvoiceRegimen: any;
  public optionsInvoiceEstado: any;
  public optionsInvoiceMunicipio: any;
  public optionsInvoiceColonia: any;
  public optionsInvoiceLocalidad: any;
  public monthsName: any = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre"
  ];
  public years: any;
  public months: any;
  public factura: any = false;
  public payMonth: any;
  public payCard: any;
  public commission: any;
  public m1: any;
  public totalPay: any;
  public payAmount: any;
  public submitted: any;
  public typeCard: string = "";
  public monthsByCards: number = 1;
  public checkTerms: boolean = false;
  public validCard: any = {
    number: false,
    card: false,
    cvv: false,
    month: false,
    year: false
  };
  private conekToken: any = null;
  public loading: any = false;

  public totalPayment: any = 0;
  urlBaseMJ: any = (<any>params).api.mj;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private searchService: SearchService,
    private integratorService: IntegratorService
  ) {
    if (!sessionStorage.getItem("passengerData")) {
      console.warn("No hay datos en la sesión");
      this.router.navigate(["/m/seguros/ups-error"]);
    }
    this.passengers = JSON.parse(sessionStorage.getItem("passengerData"));
    if (!sessionStorage.getItem("product")) {
      console.warn("No hay datos en la sesión");
      this.router.navigate(["/m/seguros/ups-error"]);
    }
    this.prod = JSON.parse(sessionStorage.getItem("product"));
    if (!sessionStorage.getItem("totales")) {
      console.warn("No hay datos en la sesión");
      this.router.navigate(["/m/seguros/ups-error"]);
    }
    let totales = JSON.parse(sessionStorage.getItem("totales"));
    this.totalViajeros = totales.totalViajeros;
    this.totalIsic = totales.totalIsic;
    this.totalNormal = totales.totalNormal;
    if (!sessionStorage.getItem("commission")) {
      console.warn("No hay datos de comisión");
      this.router.navigate(["/m/seguros/ups-error"]);
    }
    this.commission = JSON.parse(sessionStorage.getItem("commission"));
    if (!this.commission.data) {
      this.commission.data = [];
    }
    this.commission.data.unshift({
      month: 1,
      card: "American Express",
      commission: this.totalPayment
    });
    this.m1 = [
      { month: 1, card: "Visa", commission: this.totalPayment },
      { month: 1, card: "Master Card", commission: this.totalPayment },
      { month: 1, card: "American Express", commission: this.totalPayment }
    ];

    this.totalPay = this.commission.data.filter(
      c => c.card == "American Express"
    );
    this.totalPay = this.totalPay.sort((a, b) => {
      if (a.month < b.month) {
        return -1;
      }
      if (a.month > b.month) {
        return 1;
      }
      return 0;
    });
    this.months = Array.from(Array(12), (x, index) => index + 1);
    this.years = new Array(9);
    for (
      let a = Number(moment().year()), i = 0;
      a <= Number(moment().year()) + 9;
      a++, i++
    ) {
      this.years[i] = a;
    }
  }

  ngOnInit() {
    this.form = this.fb.group({
      nameReason: [
        "",
        [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÖØ-öø-ÿ\s]*$/)]
      ],
      rfc: ["", [Validators.required]],
      fiscal: ["", [Validators.required]],
      zipCode: ["", [Validators.required]],
      state: [{ value: "", disabled: true }, [Validators.required]],
      town: [{ value: "", disabled: true }, [Validators.required]],
      suburb: [{ value: "", disabled: true }, [Validators.required]],
      street: ["", [Validators.required]],
      ext: ["", [Validators.required]],
      int: ["", [Validators.required]],
      apartment: ["", [Validators.required]],
      local: [{ value: "", disabled: true }, [Validators.required]],
      email: [
        "",
        [
          Validators.required,
          Validators.email,
          Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/)
        ]
      ],
      cardOwner: ["", [Validators.required]],
      cardNumber: ["", [Validators.required, Validators.maxLength(16), Validators.minLength(15)]],
      cardCVV: [
        "",
        [Validators.required, Validators.minLength(3), Validators.maxLength(4)]
      ],
      cardMM: ["", [Validators.required]],
      cardYY: ["", [Validators.required]],
      payMonth: ["", [Validators.required]],
      factura: ["", [Validators.required]],
      promoCode: [""]
    });

    this.form.controls.factura.valueChanges.subscribe(data => {
      if (!data) {
        this.form.controls.nameReason.disable();
        this.form.controls.rfc.disable();
        this.form.controls.fiscal.disable();
        this.form.controls.zipCode.disable();
        this.form.controls.street.disable();
        this.form.controls.ext.disable();
        this.form.controls.int.disable();
        this.form.controls.apartment.disable();
        this.form.controls.email.disable();

        this.form.controls.state.disable();
        this.form.controls.town.disable();
        this.form.controls.suburb.disable();
        this.form.controls.local.disable();
      } else {
        this.form.controls.nameReason.enable();
        this.form.controls.rfc.enable();
        this.form.controls.fiscal.enable();
        this.form.controls.zipCode.enable();
        this.form.controls.street.enable();
        this.form.controls.ext.enable();
        this.form.controls.int.enable();
        this.form.controls.apartment.enable();
        this.form.controls.email.enable();

        this.form.controls.state.disable();
        this.form.controls.town.disable();
        this.form.controls.suburb.disable();
        this.form.controls.local.disable();
      }
    });

    this.form.controls.zipCode.valueChanges.subscribe(data => {
      if (data.length == 5) {
        this.getAddress(data);
      } else {
        this.optionsInvoiceEstado = [];
        this.optionsInvoiceMunicipio = [];
        this.optionsInvoiceColonia = [];
        this.optionsInvoiceLocalidad = [];
        this.form.controls.state.disable();
        this.form.controls.town.disable();
        this.form.controls.suburb.disable();
        this.form.controls.local.disable();
      }
    });

    this.form.controls.cardMM.valueChanges.subscribe(data => {
      if (data.length > 0) {
        let mes = moment().month();
        mes = Number(mes) + 1;
        let aa = moment().year();

        if (
          Number(data) < mes &&
          Number(this.form.value.cardYY) == Number(aa)
        ) {
          this.form.controls.cardMM.setValue("");
        }
      }
    });

    this.form.controls.cardYY.valueChanges.subscribe(data => {
      let mes = moment().month();
      mes = Number(mes) + 1;
      let aa = moment().year();
      if (Number(this.form.value.cardMM) < mes && Number(data) === Number(aa)) {
        console.log("ERROR");
        this.form.controls.cardMM.setValue("");
      }
    });

    this.getAllRegimes();
  }

  // Scroll TOP
  ngAfterViewInit() {
    $(document).ready(function() {
      //$('#data_payment').animate({ scrollBotton: 0 }, 'slow');
      $("html, body").animate(
        { scrollTop: $(document).height() / 1.7 },
        "slow"
      );
    });
  }

  getAllRegimes() {
    this.searchService.getRegime().subscribe(
      response => {
        var catalogue = JSON.parse(
          $(response)
            .find("GetCatalogRFResult")
            .text()
        );
        this.optionsInvoiceRegimen = [];
        catalogue.forEach(element => {
          this.optionsInvoiceRegimen.push({
            value: element.code,
            text: element.description
          });
        });
      },
      error => {
        console.error("Error al obtener regimen", error);
        this.router.navigate(["/m/seguros/ups-error"]);
      }
    );
  }

  getAddress(zipCode) {
    this.optionsInvoiceEstado = [{ value: null, text: "Cargando..." }];
    this.optionsInvoiceMunicipio = [{ value: null, text: "Cargando..." }];
    this.optionsInvoiceColonia = [{ value: null, text: "Cargando..." }];
    this.optionsInvoiceLocalidad = [{ value: null, text: "Cargando..." }];

    let address = {
      cp: zipCode,
      estado: "",
      municipio: "",
      localidad: "",
      colonia: ""
    };

    this.searchService.getAddress(address).subscribe(
      response => {
        var address = JSON.parse(
          $(response)
            .find("GetAddressesResult")
            .text()
        );
        this.optionsInvoiceEstado = [];
        this.optionsInvoiceMunicipio = [];
        this.optionsInvoiceColonia = [];
        this.optionsInvoiceLocalidad = [];

        this.optionsInvoiceEstado.push({
          value: address[0].claveEstado,
          text: address[0].estado
        });
        this.optionsInvoiceMunicipio.push({
          value: address[0].claveMunicipio,
          text: address[0].municipio
        });
        this.optionsInvoiceColonia.push({
          value: address[0].claveColonia,
          text: address[0].colonia
        });
        this.optionsInvoiceLocalidad.push({
          value: address[0].claveLocalidad,
          text: address[0].localidad
        });

        this.form.controls.state.enable();
        this.form.controls.town.enable();
        this.form.controls.suburb.enable();
        this.form.controls.local.enable();
      },
      error => {
        console.error("Error al obtener address", error);
        this.optionsInvoiceEstado = [];
        this.optionsInvoiceMunicipio = [];
        this.optionsInvoiceColonia = [];
        this.optionsInvoiceLocalidad = [];
        this.form.controls.state.disable();
        this.form.controls.town.disable();
        this.form.controls.suburb.disable();
        this.form.controls.local.disable();
        // this.router.navigate(['ups-error'])
      }
    );
  }

  acceptTermns({ checked }) {
    this.checkTerms = checked;
  }

  nextStep() {
    this.buildGeneralDataLayer();
    if (this.checkTerms) {
      this.loading = true;
      this.submitted = true;
      this.tokenizar();
    }
  }

  tokenizar() {
    var self = this;
    var Conekta = (window as any).Conekta;
    if (this.passengers.email === 'ecommerce@mundojoven.com') {
      //key dev
     Conekta.setPublicKey('key_PmtDS3KQfxBuqCvBhn7GE7w');
   }else{
     //Key prod
     Conekta.setPublicKey('key_e3VGWqaG2TEZFNHMdEMG1Vw');
   }

    var conektaSuccessResponseHandler = function(token) {
      self.conekToken = token;
      self.cotizar();
    };

    var conektaErrorResponseHandler = function(response) {
      this.loading = false;
    };

    let tokenParams = { card: {} };
    tokenParams.card = {
      number: this.form.value.cardNumber,
      name: this.form.value.cardOwner,
      exp_year: this.form.value.cardYY,
      exp_month: this.form.value.cardMM,
      cvc: this.form.value.cardCVV
    };

    var validateNumber = Conekta.card.validateNumber(
      (tokenParams.card as any).number
    );
    var validateExpirationDate = Conekta.card.validateExpirationDate(
      (tokenParams.card as any).exp_month,
      (tokenParams.card as any).exp_year
    );
    var validateCVC = Conekta.card.validateCVC((tokenParams.card as any).cvc);
    var getBrand = Conekta.card.getBrand((tokenParams.card as any).number);

    if (!validateNumber) {
      // this.errors.push({input: 'creditcard-number', description: 'Tarjeta de crédito no valida'})
      // $('#' + 'creditcard-number').removeClass('is-valid').addClass('is-invalid')
      this.validCard.number = false;
      this.loading = false;
    } else {
      this.validCard.number = true;
    }

    if (!validateExpirationDate) {
      // this.errors.push({input: 'creditcard-expirationMonth', description: 'Fecha de expiración de la tarjeta de crédito no valida'})
      // $('#' + 'creditcard-expirationMonth').removeClass('is-valid').addClass('is-invalid')
      // $('#' + 'creditcard-expirationYear').removeClass('is-valid').addClass('is-invalid')
      this.validCard.month = false;
      this.validCard.year = false;
      this.loading = false;
    } else {
      this.validCard.month = true;
      this.validCard.year = true;
    }

    if (!validateCVC) {
      // this.errors.push({input: 'creditcard-cvv', description: 'Código de seguridad de la tarjeta de crédito no valido'})
      // $('#' + 'creditcard-cvv').removeClass('is-valid').addClass('is-invalid')
      this.validCard.cvv = false;
      this.loading = false;
    } else {
      this.validCard.cvv = true;
    }

    if (validateNumber && validateExpirationDate && validateCVC) {
      if (
        getBrand === 'visa' ||
        getBrand === 'mastercard' ||
        getBrand === 'amex'
      ) {
        Conekta.token.create(
          tokenParams,
          conektaSuccessResponseHandler,
          conektaErrorResponseHandler
        );
      }
    }
  }

  cotizar() {
    let upgrates = sessionStorage.getItem('addOns')
      ? JSON.parse(sessionStorage.getItem('addOns'))
      : [];

    // Petición a enviar para compra:
    let pasajeros = this.passengers.passengerDataList;
    let pasajerosForm = [];
    pasajeros.forEach(element => {
      // Busco la comision que necesito
      pasajerosForm.push({
        voucherProductId: element.isic
          ? Number(this.prod.vouchers[1].productId)
          : Number(this.prod.vouchers[0].productId),
        passengerDocumentTypeId: 1, // Se manda 1
        passengerDocumentNumber: Math.floor(
          Math.random() * 10000000000000000000 + 1
        ), // Número aleatorio
        passengerBirthDate: `${element.birthdayD}/${element.birthdayM}/${element.birthdayY}`,
        passengerGender: element.gender,
        passengerFirstName: element.name,
        passengerLastName: element.lastName,
        passengerSecondName: element.secondLastName,
        passengerCountryId: sessionStorage.getItem('internacional')
          ? sessionStorage.getItem('internacional').includes('true')
            ? 9999
            : 140
          : 9999,
        passengerCity: 'mex',
        passengerAddress: ' - ',
        passengerPhone: this.passengers.phone,
        passengerEmail: this.passengers.email,
        productName: element.isic
          ? this.prod.vouchers[1].productName
          : this.prod.vouchers[0].productName,
        productPrice: element.isic
          ? Number(this.prod.vouchers[1].priceUsd) / this.prod.vouchers[1].quantity
          : Number(this.prod.vouchers[0].priceUsd) / this.prod.vouchers[0].quantity,
        discount: element.isic
          ? this.prod.vouchers[1].discount
          : this.prod.vouchers[0].discount
      });
    });

    const compra = {
      country: "mexico",
      voucherDateFrom: this.prod.vouchers[0].dateFrom,
      voucherDateTo: this.prod.vouchers[0].dateTo,
      voucherIntRef: "1",
      countryId: sessionStorage.getItem("internacional")
        ? sessionStorage.getItem("internacional").includes("true")
          ? 9999
          : 140
        : 9999,
      conversionRate: Number(this.prod.vouchers[0].conversionRate),
      crossSelling: sessionStorage.getItem("crossSelling")
        ? sessionStorage.getItem("crossSelling").includes("true")
          ? true
          : false
        : false,
      customer: {
        name: this.passengers.name,
        lastName: this.passengers.lastName,
        secondLastName: this.passengers.secondLastName,
        email: this.passengers.email,
        telephone: this.passengers.phone,
        mobile: this.passengers.mobile
      },
      payment: {
        paymentType: "pago_unico", // Revisar tipo de pago
        commission: this.payAmount ? parseFloat(this.payAmount.commission) : 0,
        month: this.payMonth,
        token: this.conekToken.id,
        total: parseFloat(this.totalPayment),
        paymentCardType: 1
      },
      passengers: pasajerosForm,
      emergency: {
        passengerEmergencyFirstName: this.passengers.name_em,
        passengerEmergencyLastName: this.passengers.lastName_em,
        passengerEmergencyPhone1: this.passengers.phone_em,
        passengerEmergencyPhone2: this.passengers.phone_em
      },
      quote: {
        // Servicio integrador
        sessionName: "",
        contactID: "",
        contactNumber: "",
        idCRM: "4x659731",
        quoteId: "4x659731",
        quoteNumber: ""
      },
      invoice: {
        name: this.form.value.nameReason,
        rfc: this.form.value.rfc,
        email: this.form.value.email,
        state: this.form.value.state,
        town: this.form.value.town,
        suburb: this.form.value.suburb,
        location: this.form.value.local ? this.form.value.local : "",
        regimen: this.form.value.factura ? this.form.value.fiscal : "616",
        street: this.form.value.street,
        noExt: this.form.value.ext,
        noInt: this.form.value.int,
        apartment: this.form.value.apartment,
        zipCode: this.form.value.zipCode
      },
      utmCampaign: "",
      utmMedium: "",
      utmSource: "",
      upgrates: upgrates
    };

    this.getIntegrator(compra);
  }

  getIntegrator(dataIntegrator) {
    var self = this;
    this.integratorService.integrator(dataIntegrator, this.form.value);
    sessionStorage.setItem("integrador", null);

    let integrador = new Promise((resolve, reject) => {
      var checking = setInterval(checkIntegrator, 100);
      function checkIntegrator() {
        let int = JSON.parse(sessionStorage.getItem("integrador"));
        if (int) {
          switch (int.step) {
            case 3:
              if (int.data) {
                clearInterval(checking);
                resolve(int.data);
              }
            default:
              if (int.error) {
                clearInterval(checking);
                this.loading = false;
              }
              break;
          }
        }
      }
    });

    integrador.then(value => {
      const dataPurchase = dataIntegrator;
      dataPurchase.quote.sessionName = (value as any).sessionname;
      dataPurchase.quote.contactID = (value as any).contact.contact_id;
      dataPurchase.quote.contactNumber = (value as any).contact.contact_no;
      dataPurchase.quote.quoteNumber = (value as any).quote.quote_no;
      dataPurchase.sender = 'WEBMUNDOJOVEN';

      this.integratorService.purchase(dataPurchase).subscribe(
        (data: any) => {

          if (data.status !== false) {
            const respData = data.data;
            const numberQuote = data.data.numberQuote;
            this.integratorService.operatingConsoleInsurance(numberQuote).subscribe((data: any) => {
              this.integratorService.updateInformation(numberQuote, respData, dataPurchase).subscribe((_data) => {});
            });

            //CAMBIAR A THKPAGE
            let urlBase = "https://mundojoven.com/gracias-seguros/?";
            urlBase = urlBase.concat("ref=", data.data.reference);
            urlBase = urlBase.concat("&statusID=true&type=null");
            urlBase = urlBase.concat(
              "&Name=",
              encodeURIComponent(this.passengers.name)
            );
            urlBase = urlBase.concat(
              "&LastName=",
              encodeURIComponent(this.passengers.lastName)
            );
            urlBase = urlBase.concat("&Tel=", this.passengers.mobile);
            urlBase = urlBase.concat("&Email=", this.passengers.email);

            this.router.navigate(['/seguros/gracias_seguros'], {
              queryParams: {
                key: data.data.reference,
                name: this.passengers.name,
                lastname: this.passengers.lastName,
                email: this.passengers.email,
                tel: this.passengers.mobile,
                totalPayment: this.totalPayment,
                status: JSON.stringify(data.data)
              }
            });
          } else {
            this.loading = false;
            this.router.navigate(['/seguros/gracias_seguros'], {
              queryParams: {
                name: this.passengers.name,
                lastname: this.passengers.lastName,
                email: this.passengers.email,
                tel: this.passengers.mobile,
                totalPayment: this.totalPayment,
                status: JSON.stringify(data.data)
              }
            });
          }
        },
        err => {
          this.loading = false;
          let urlBase = "https://mundojoven.com/gracias-seguros/?";
          urlBase = urlBase.concat("ref=", err.data.reference);
          urlBase = urlBase.concat("&statusID=true&type=null");
          urlBase = urlBase.concat("&errorPNR=Rechazado");
          urlBase = urlBase.concat(
            "&Name=",
            encodeURIComponent(this.passengers.name)
          );
          urlBase = urlBase.concat(
            "&LastName=",
            encodeURIComponent(this.passengers.lastName)
          );
          urlBase = urlBase.concat("&Tel=", this.passengers.mobile);
          urlBase = urlBase.concat("&Email=", this.passengers.email);
        }
      );
    });
  }

  soloLetras(e){
    let key = e.keyCode || e.which;
    let tecla = String.fromCharCode(key).toLowerCase();
    let letras = " áéíóúabcdefghijklmnñopqrstuvwxyzABCDEFGHIJKLMNÑOPQRSTWXYZ";
    const especiales = [8, 37, 39, 46];
    let tecla_especial = false;
    for(var i in especiales){
      if (key === especiales[i]) {
        tecla_especial = true;
        break;
      }
    }
    if (letras.indexOf(tecla) ==- 1 && !tecla_especial) {
      return false;
    }
  }

  keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  checkMonthsInteres() {
    if (this.payCard && this.form.value.payMonth) {
      this.payAmount =
        this.form.value.payMonth > 1
          ? this.commission.data.filter(
              p => p.card == this.payCard && p.month == this.form.value.payMonth
            )[0]
          : { month: 1, card: this.payCard, commission: 0 };

      this.payMonth = this.form.value.payMonth;
    }
  }

  checkCard() {
    if (this.form.value.cardNumber != "") {
      // AMEX
      let re;
      re = new RegExp("^3[47]");
      if (this.form.value.cardNumber.match(re) != null) {
        this.typeCard = "AMEX";
      }

      // Visa Electron
      re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
      if (this.form.value.cardNumber.match(re) != null) {
        this.typeCard = "Visa Electron";
      }

      // Visa
      re = new RegExp("^4");
      if (this.form.value.cardNumber.match(re) != null) {
        this.typeCard = 'Visa';
      }

      // Mastercard
      re = new RegExp('^5[1-5]');
      if (this.form.value.cardNumber.match(re) != null) {
        this.typeCard = 'Master Card';
      }
      this.payCard = this.typeCard;
      this.commission.data.sort((a, b) =>
        a.month > b.month ? 1 : b.month > a.month ? -1 : 0
      );
      this.monthsByCards = this.commission.data.filter(
        tar => tar.card === this.payCard
      );
    } else {
      this.form.value.payMonth = 1;
    }
  }

  buildGeneralDataLayer() {
    const url = sessionStorage.getItem('url');
    const param_pair_string = url.split('&');
    const date_start = param_pair_string.filter(rep =>  rep.includes('dateFrom'));
    const departing_departure_date = date_start[0].split('=')[1].replace('%2', '').replace('F', '-').replace('%2F', '-');

    const date_end = param_pair_string.filter(rep =>  rep.includes('dateTo'));
    const returning_departure_date = date_end[0].split('=')[1].replace('%2', '').replace('F', '-').replace('%2F', '-');

    const data = {
      name: `${this.form.value.name}` ,
      id: this.prod.vouchers[0].productId,
      price: this.totalPayment,
      insurance_payment_data: this.payAmount,
      departing_departure_date: departing_departure_date.split("-").reverse().join("-"),
      returning_departure_date: returning_departure_date.split("-").reverse().join("-"),
      content_type: 'insurance',
      currency: 'MXN',
      page_category: 'search',
      url_search: this.router.url,
      visitor_type: 'medium-value',
      product_name_insurances: this.prod.vouchers[0].productName,
      date_search: moment(new Date()).format('YYYY-MM-DD'),
      time_search: moment(new Date()).format('HH:mm')
    };

    window.dataLayer.push({
      'event': 'insurance_from_customer',
      'valData': data,
      'insurance_from_customer': data
    });
  }
}
